<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c29/guide01.jpg" alt="보습제 MD샘플키트 이벤트 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c29/guide02.jpg" alt="보습제 MD샘플키트 이벤트 (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c29/guide03.jpg" alt="보습제 MD샘플키트 이벤트 (다음 내용 참조)" />
        <img class="imgs last" src="../../../assets/c29/guide04.jpg" alt="보습제 MD샘플키트 이벤트 (다음 내용 참조)" />
        <div class="sr-only">
          <span>2월 18일까지 진행되는 경품추천 이벤트입니다</span>
          <h1>솔닥 보습제 MD 샘플키트 이벤트</h1>
          <span>응모하신 분 중 추첨을 통해 솔닥 인기 보습제 샘플 키트를 보내드립니다</span>
          <strong>매일 30명 한정, 총 30일 간</strong>
          <span>상단 공유 버튼을 통해 친구, 가족에게 이벤트를 공유하면 당첨 확률 UP</span>
          <h2>솔닥 보습제 MD 샘플 키트 소개</h2>
          <span>솔닥 인기 보습제 MD 샘플로 구성된 키트를 소개합니다</span>
          <strong>솔닥 처방 가능 보습제 MD 라인업</strong>
          <span>하늘색 표시 : 솔닥 보습제 MD 샘플 키트에서 만나보실 수 있어요!</span>
          <table>
            <caption>솔닥 보습제 md 라인업 목록이며 브랜드명, 상품명, 용량에 대한 정보 제공</caption>
            <colgroup>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">브랜드명</th>
                <th scope="col">상품명</th>
                <th scope="col">용량</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>제로이드</td>
                <td>제로이드인텐시브 MD로션</td>
                <td>300ml</td>
              </tr>
              <tr>
                <td>제로이드</td>
                <td>제로이드인텐시브 MD크림(하늘색 표시)</td>
                <td>160ml</td>
              </tr>
              <tr>
                <td>제로이드</td>
                <td>제로이드리치 MD크림(하늘색 표시)</td>
                <td>160ml</td>
              </tr>
              <tr>
                <td>제로이드</td>
                <td>제로이드 더마 쉴드 크림 엠디 MD</td>
                <td>50g</td>
              </tr>
              <tr>
                <td>제로이드</td>
                <td>제로이드 루트힐 모이스처라이저 MD</td>
                <td>300ml</td>
              </tr>
              <tr>
                <td>제로이드</td>
                <td>써지엔젤 플러스MD</td>
                <td>10g</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>아토베리어 MD로션(하늘색 표시)</td>
                <td>300ml</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>아토베리어 MD크림(하늘색 표시)</td>
                <td>160ml</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>아토베리어 AI MD크림</td>
                <td>160ml</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>아토베리어 잇칭 크림 MD</td>
                <td>160g</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>에스트라 MD크림</td>
                <td>160ml</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>더마 베이비 PRO 로션MD</td>
                <td>300ml</td>
              </tr>
              <tr>
                <td>에스트라</td>
                <td>더마 베이비 PRO 크림MD</td>
                <td>160g</td>
              </tr>
              <tr>
                <td>셀퓨전씨</td>
                <td>셀퓨전씨 엑스퍼트 배리덤 로션MD (하늘색 표시)</td>
                <td>300g / 500g</td>
              </tr>
              <tr>
                <td>셀퓨전씨</td>
                <td>셀퓨전씨 엑스퍼트 배리덤 크림MD (하늘색 표시)</td>
                <td>150g / 250g</td>
              </tr>
              <tr>
                <td>셀퓨전씨</td>
                <td>셀퓨전씨 엑스퍼트 배리덤 쉴드크림MD (하늘색 표시)</td>
                <td>35g / 80g</td>
              </tr>
              <tr>
                <td>이지듀</td>
                <td>이지듀 MD 크림</td>
                <td>85g/200g</td>
              </tr>
              <tr>
                <td>이지듀</td>
                <td>이지듀 MD 리젠크림</td>
                <td>85g/150g</td>
              </tr>
              <tr>
                <td>리쥬더마</td>
                <td>리쥬더마 아토크림MD</td>
                <td>230ml</td>
              </tr>
            </tbody>
          </table>
          <h2>솔닥은 왜 보습제 MD 샘플 키트를 만들었을까요?</h2>
          <p>모든 피부에게 알맞은 완벽한 보습제는 없습니다.</p>
          <p>기분이 매일 바뀌는 것처럼, 피부 컨디션도 각자 매일매일 다르기 때문이죠.</p>
          <h3>doctor's tip</h3>
          <p>먼저 하루 이틀정도 제품 테스트를 해보는 것도 좋습니다. 먼저 귀 뒤쪽이나 팔 안쪽 등 얇은 피부에 하루 이틀 정도 테스트 도포를 해보고 특별히 불편한 점이 없다면 얼굴과 몸 전체에 적당량 도포를 시작해보시는 것을 권장합니다.</p>
          <span>솔닥은 보습제 MD 최다 라인업을 보유하고 있습니다.</span>
          <span>솔닥에서 맞춤형 보습제를 찾아보세요</span>
          <h2>이벤트 참여 방법</h2>
          <strong>이벤트 응모하기 클릭</strong>
          <span>이벤트 응모하기 버튼을 눌러 간단히 참여하세요!</span>
          <strong>이벤트에 당첨 된다면?</strong>
          <span>당첨 알림 확인 후, 앱에서 배송 받을 주소를 입력하세요. 샘플키트를 곧 받아보실 수 있어요!</span>
          <strong>아쉽게 낙첨 된다면...</strong>
          <span>괜찮아요! 내일 다시 참여해서 샘플 키트에 도전하세요!</span>
          <span>TIP 공유 버튼을 눌러서 친구에게 공유하면 당첨 확룔 up!</span>
          <h2>이벤트 유의사항</h2>
          <ul>
            <li>솔닥 ID당 1일 1회만 응모 가능합니다.</li>
            <li>샘플 키트 이벤트에 당첨된 사람은 이벤트 다시 참여할 수 없습니다.</li>
            <li>경품은 당첨 후 기입된 연락처, 주소로 우편 배송되며, 오기입으로 인한 경품 미수령은 재발송되지 않습니다.</li>
            <li>경품으로 제공된 상품은 교환/환불 불가능합니다.</li>
            <li>경품은 매주 월요일 일괄 배송됩니다.</li>
            <li>이벤트 일정 및 경품은 당사 사정에 따라 사전 안내 없이 변경될 수 있습니다.</li>
            <li>본 이벤트 기간 내 사용자 정보를 입력하지 않은 경우 이벤트 당첨이 취소됩니다.</li>
          </ul>
        </div>
    </div>
</template>

<script>
export default {
	name: "c29",
	methods: {}
};
</script>

<style scoped>
	.contain {
		width: 100%;
		position: relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: column;
		min-width: 800px;
	}   
  .contain .sr-only {
      position: absolute;
      left: -9999px;
      width: 1px;
      height: 1px;
      margin: 0 !important;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
  }
  .imgs.last {
    padding-bottom: 126px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c29.vue